import { axiosInstance } from '../api/ApiConfig';

async function SendFeedback(data) {
  try {
    const response = await axiosInstance.post('/feedback', data);

    return response.status === 200;
  } catch (error) {
    console.error('Response from server = ', error);

    if (error.response) {
      const { status, data } = error.response;
      const message = data?.detail || `Request failed with status ${status}`;
      throw new Error(message);
    }

    if (error.request) {
      throw new Error('Network error: No response from server');
    }

    throw new Error(`Request failed: ${error.message}`);
  }
}

export default SendFeedback;
